export function toCode(s: number, length: number = 2) {
    return s.toString().padStart(length, "0");
}